import { blogSources } from '@/content/blogs'
import { resolvePublicContentLocale } from '../../functions/public-content-locale.js'
import {
  createUrlWithLanguage,
  isValidLanguageCode,
  stripLanguagePrefix,
  withLanguagePath,
} from './url-language-utils'

export function publicLanguageSwitchUrl(language: string, baseUrl?: string): string {
  const selected = isValidLanguageCode(language) ? language : 'en'
  const sourceUrl = baseUrl
    ?? (typeof window === 'undefined' ? 'https://mentiss.ai/en' : window.location.href)
  const url = new URL(createUrlWithLanguage(selected, sourceUrl))
  const pagePath = stripLanguagePrefix(url.pathname).replace(/\/$/, '') || '/'
  const articleMatch = /^\/blogs\/(?:(?:en|zh)\/)?([^/]+)$/.exec(pagePath)

  if (articleMatch) {
    const articlePath = `/blogs/${articleMatch[1]}`
    const source = blogSources.find(entry => entry.id === articleMatch[1])
    const actual = source
      ? resolvePublicContentLocale(
          articlePath,
          selected,
          Object.keys(source.locales) as Array<typeof selected>,
        )
      : selected
    url.pathname = withLanguagePath(articlePath, actual ?? selected)
  }
  else {
    const actual = resolvePublicContentLocale(pagePath, selected)
    url.pathname = withLanguagePath(pagePath, actual ?? selected)
  }

  return url.toString()
}
